export const ViewerType = 'wixui.Submenu' as const;
export const DataType = 'Submenu';
export const LayerPanelIconLabel = 'MegaMenu';

export const TranslationKeys = {
  designPanel: {
    item: 'submenu_inspector_design_dropdown_items',
    subItem: 'submenu_inspector_design_dropdown_sub-items',
    container: 'submenu_inspector_design_dropdown_container',
  },
};

export const HelpIds = {
  gfpp: 'component-editors.wixui.Submenu_help',
  layout: 'aa127566-9019-41ff-b4d5-2e49910b3c72',
};

export const DataHooks = {
  submenu: 'submenu',
} as const;
